import FormattedAddress from "components/Atoms/FormattedAddress";
import SubLabel from "components/Atoms/Sublabel";
import React from "react";
import { isAdminAndVisitingAddressSame } from "utilities/companyUtils";
interface Props {
  company: server.dto.Company
}

export const PostalAddressPreviewPanel = ({ company }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(company);
  if (isSameAsVisitingAddress) {
    return <SubLabel>Same as visiting address</SubLabel>;
  }

  return <div>
    <div>{company.admName}</div>
    <div className="text-sublabel">{company.admAddress.formatted.join(", ")}</div>
  </div>;
}

const PostalAddress = ({ company }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(company);
  if (isSameAsVisitingAddress) {
    return <SubLabel>Same as visiting address</SubLabel>;
  }

  return <div>
    <div>{company.admName}</div>
    <FormattedAddress address={company.admAddress} />
  </div>
};

export default PostalAddress;